export default {"section":"-yq1r","textWrapper":"kDf2t"};